__turbopack_context__.v({
  "accordion": "AiPoweredAnalyticsPage-module__rd_meG__accordion",
  "body": "AiPoweredAnalyticsPage-module__rd_meG__body",
  "eyebrow": "AiPoweredAnalyticsPage-module__rd_meG__eyebrow",
  "faqBody": "AiPoweredAnalyticsPage-module__rd_meG__faqBody",
  "faqBodyClosed": "AiPoweredAnalyticsPage-module__rd_meG__faqBodyClosed",
  "faqBodyInner": "AiPoweredAnalyticsPage-module__rd_meG__faqBodyInner",
  "faqBodyOpen": "AiPoweredAnalyticsPage-module__rd_meG__faqBodyOpen",
  "faqBtn": "AiPoweredAnalyticsPage-module__rd_meG__faqBtn",
  "faqBtnOpen": "AiPoweredAnalyticsPage-module__rd_meG__faqBtnOpen",
  "faqHeader": "AiPoweredAnalyticsPage-module__rd_meG__faqHeader",
  "faqIcon": "AiPoweredAnalyticsPage-module__rd_meG__faqIcon",
  "faqItem": "AiPoweredAnalyticsPage-module__rd_meG__faqItem",
  "future": "AiPoweredAnalyticsPage-module__rd_meG__future",
  "futureGrid": "AiPoweredAnalyticsPage-module__rd_meG__futureGrid",
  "futureImage": "AiPoweredAnalyticsPage-module__rd_meG__futureImage",
  "futureImageCol": "AiPoweredAnalyticsPage-module__rd_meG__futureImageCol",
  "futureShape": "AiPoweredAnalyticsPage-module__rd_meG__futureShape",
  "h2": "AiPoweredAnalyticsPage-module__rd_meG__h2",
  "heroCopy": "AiPoweredAnalyticsPage-module__rd_meG__heroCopy",
  "heroCta": "AiPoweredAnalyticsPage-module__rd_meG__heroCta",
  "heroDots": "AiPoweredAnalyticsPage-module__rd_meG__heroDots",
  "heroHeader": "AiPoweredAnalyticsPage-module__rd_meG__heroHeader",
  "heroImage": "AiPoweredAnalyticsPage-module__rd_meG__heroImage",
  "heroImageWrap": "AiPoweredAnalyticsPage-module__rd_meG__heroImageWrap",
  "heroInner": "AiPoweredAnalyticsPage-module__rd_meG__heroInner",
  "heroParagraph": "AiPoweredAnalyticsPage-module__rd_meG__heroParagraph",
  "heroTitle": "AiPoweredAnalyticsPage-module__rd_meG__heroTitle",
  "page": "AiPoweredAnalyticsPage-module__rd_meG__page",
  "sectionLead": "AiPoweredAnalyticsPage-module__rd_meG__sectionLead",
  "sectionTitle": "AiPoweredAnalyticsPage-module__rd_meG__sectionTitle",
  "signUpBanner": "AiPoweredAnalyticsPage-module__rd_meG__signUpBanner",
  "signUpBannerCopy": "AiPoweredAnalyticsPage-module__rd_meG__signUpBannerCopy",
  "signUpBannerForm": "AiPoweredAnalyticsPage-module__rd_meG__signUpBannerForm",
  "signUpBannerFormHeading": "AiPoweredAnalyticsPage-module__rd_meG__signUpBannerFormHeading",
  "signUpBannerFormWrap": "AiPoweredAnalyticsPage-module__rd_meG__signUpBannerFormWrap",
  "signUpBannerHeading": "AiPoweredAnalyticsPage-module__rd_meG__signUpBannerHeading",
  "signUpBannerInner": "AiPoweredAnalyticsPage-module__rd_meG__signUpBannerInner",
  "signUpBannerParagraph": "AiPoweredAnalyticsPage-module__rd_meG__signUpBannerParagraph",
  "signUpBannerSubheading": "AiPoweredAnalyticsPage-module__rd_meG__signUpBannerSubheading",
  "signUpSourceForm": "AiPoweredAnalyticsPage-module__rd_meG__signUpSourceForm",
  "solutionsIntro": "AiPoweredAnalyticsPage-module__rd_meG__solutionsIntro",
});
